import { createFileRoute } from "@tanstack/react-router";
import { PortalVipGate } from "@/components/portal/PortalVipGate";

export const Route = createFileRoute("/portal-vip/")({
  component: () => <PortalVipGate segments={[]} />,
});
